import { sva } from '@onbeam/business-styled-system/css';

export const hoverCard = sva({
  className: 'hoverCard',
  slots: ['content', 'hidden', 'arrow'],
  base: {
    content: {
      zIndex: 50,
      animationName: 'fadeIn',
      animationDuration: 'fast',
      bg: 'mono.primaryFg',
      rounded: 'md',
      shadow: 'sm',
      border: '[1px solid]',
      borderColor: 'opacity.md',
      p: '1',
      pointerEvents: 'all',

      _closed: {
        animationName: 'fadeOut',
      },
    },
    hidden: {
      srOnly: true,
    },
    arrow: {
      zIndex: 5,
      position: 'absolute',
      top: '[calc(-0.35rem - 0.5px)]',
      width: '[0.7rem]',
      height: '[0.7rem]',
      bg: 'mono.primaryFg',
      borderColor: 'opacity.md',
      transform: 'rotate(45deg) translate(-50%, 50%)',
      transformOrigin: 'center',
      borderRight: '[1px solid]',
      borderBottom: '[1px solid]',
      roundedBottomRight: '[2px]',
      pointerEvents: 'none',

      '& *': {
        display: 'none',
      },
    },
  },
});
